/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { CalendarSettingsValues } from './calendarSettingsModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'calendar-settings-modal',
    standalone: false,
})
export class CalendarSettingsModalDirective extends UpgradeComponent {
    @Output() dismiss: EventEmitter<any>;
    @Input() resolve: CalendarSettingsValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('calendarSettingsModal', elementRef, injector);
    }
}
